import React from 'react';
import { HANDBUCH_FARBEN } from './stil';

/**
 * Kopfzeile einer Handbuchseite.
 *
 * Portiert aus `components/document/DocumentHeader.tsx` der Quell-App. Zwei
 * Unterschiede, beide mit Grund:
 *
 * 1. Die Vorlage greift sich Projekt, Bauherr und Vergabemodell selbst aus
 *    einem `Projekt`-Objekt. Hier kommen sie als einzelne Zeichenketten
 *    herein. Die Datenquellen liegen in OS-IA weit auseinander — Projektname
 *    im Report, Bauherr in `metadata`, Vergabemodell in `handbuecher` — und
 *    ein Baustein, der sich seine Daten selbst zusammensucht, muesste alle
 *    drei kennen.
 * 2. Die Ueberschrift ist ein Prop. Die Kapitel gehoeren zum SIGE-HANDBUCH,
 *    der Aushang aus AP5 traegt eine andere Zeile — und die Vorlage schrieb
 *    „SICHERHEITS- UND GESUNDHEITSSCHUTZPLAN" fest hinein, was hier schlicht
 *    das falsche Dokument benennt: der Plotterplan ist ein anderes Blatt.
 */

interface Props {
    /** Grosse Zeile links. */
    titel?: string;
    /** Kleine Zeile darunter — die Rechtsgrundlage. */
    untertitel?: string;
    projektName?: string;
    bauherr?: string;
    orgModell?: string;
    /** Stand des Dokuments, bereits als Text formatiert. */
    stand?: string;
    /** Fassung, wie sie auf dem Blatt erscheint. */
    fassung?: string;
}

const zeile = (bezeichnung: string, wert?: string) => (wert ? (
    <div><strong>{bezeichnung}:</strong> {wert}</div>
) : null);

export const SeitenKopf: React.FC<Props> = ({
    titel = 'SICHERHEITS- UND GESUNDHEITSSCHUTZ-HANDBUCH',
    untertitel = 'gemäß Baustellenverordnung (BaustellV) / RAB 31',
    projektName, bauherr, orgModell, stand, fassung,
}) => (
    <div
        className="flex justify-between items-start gap-4"
        style={{
            borderBottom: `2px solid ${HANDBUCH_FARBEN.linieStark}`,
            paddingBottom: '5px',
            marginBottom: '10px',
        }}
    >
        <div className="min-w-0">
            <div style={{ fontSize: '14px', fontWeight: 700, letterSpacing: '0.02em' }}>
                {titel}
            </div>
            <div style={{ fontSize: '9px', color: HANDBUCH_FARBEN.textLeise, marginTop: '1px' }}>
                {untertitel}
            </div>
        </div>
        <div
            className="text-right shrink-0"
            style={{ fontSize: '8.5px', color: HANDBUCH_FARBEN.textLeise }}
        >
            {zeile('Projekt', projektName)}
            {zeile('Bauherr', bauherr)}
            {/* Steht auch dann da, wenn es „noch nicht bestimmt" heisst: ein
                leeres Feld liest sich, als gaebe es kein Vergabemodell. */}
            {zeile('Org.-Modell', orgModell)}
            {(stand || fassung) && (
                <div>
                    {stand && <><strong>Stand:</strong> {stand}</>}
                    {stand && fassung && ' | '}
                    {fassung && <><strong>Fassung:</strong> {fassung}</>}
                </div>
            )}
        </div>
    </div>
);
